import Select from "react-select";
import React from "react";

const ReactSelectForm = ({fieldName, options, value, placeholder,
                             isMulti, isClearable, setFieldValue, isDisabled, defaultValue, onChangeFunction, customStyles, required, name}) => {
    return <Select
        name={name}
        onChange={(current, action) => {
            if (!current) {
                setFieldValue(fieldName, '');
                return;
            }
            if (!Array.isArray(current)) {
                setFieldValue(fieldName, current.value);
            } else {
                let currentList = [];
                current.forEach(c => currentList.push(c?.value));
                setFieldValue(fieldName, currentList);
            }
        if (onChangeFunction) onChangeFunction(current.value, fieldName);
        }}
        styles={{
            menu: provided => ({...provided, zIndex: 9999}),
            ...customStyles
        }}
        value={value}
        placeholder={placeholder}
        components={{IndicatorSeparator: () => null}}
        options={options}
        isClearable={isClearable ?? false}
        isMulti={isMulti ?? false}
        isDisabled={isDisabled ?? false}
        defaultValue={defaultValue}
        required={required ?? false}
    />
}

export default ReactSelectForm;